import { createRouter, RouterProvider as TanStackRouterProvider } from '@tanstack/react-router';
import { routeTree } from '@/routeTree.gen';

// Vytvoření router instance s typově bezpečným route tree
export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
});

// Deklarace typů pro TypeScript
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

/**
 * Router provider pro TanStack Router.
 * Používá se v App komponentu pro poskytnutí routovací logiky celé aplikaci.
 */
export function RouterProvider() {
  return <TanStackRouterProvider router={router} />;
}
